import { PureComponent, createRef } from 'react';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    SubTitle,
} from 'chart.js';

import { Bar } from 'react-chartjs-2'
// import { redirect } from 'react-router-dom';
// import { getQueriesForElement } from '@testing-library/react';
// import ChartAnnotation from 'chartjs-plugin-annotation';

import annotationPlugin from 'chartjs-plugin-annotation';
// import '../admin.css';

// Chart.register(annotationPlugin);


ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    SubTitle,
    annotationPlugin,
);

// ChartJS.plugins.register([ChartAnnotation]);
// ChartJS.plugins.register(
//     {
//         beforeDraw: function (chart) {
//             alert("hallo");
//             if (chart.config.data.datasets[0].labelColor) {
//                 let legends = chart.legend.legendItems;
//                 legends.forEach(function (e, i) {
//                     e.fillStyle = chart.config.data.datasets[i].labelColor;
//                     e.strokeStyle = chart.config.data.datasets[i].labelColor;
//                 });
//             }
//             else {
//                 console.log("no label color");
//             }
//         }
//     }
// );

export class BarChartSingle extends PureComponent {
    myBarChartRef = createRef(null);

    fooTheMoo = () => {
        this.myBarChartRef.current.data.datasets[0].data[2] = 23;
        this.myBarChartRef.current.data.datasets[0].backgroundColor[0] = "rgba(0,0,255,1)";
        this.myBarChartRef.current.data.datasets[0].label = "HDJD";
        this.myBarChartRef.current.update();
    }

    componentDidMount() {
        // const myTimeout = setTimeout(this.fooTheMoo, 23);
    }

    formatXValue = (x) => {
        // console.log(x);
        return "hallo_X";
    }

    formatYValue = (y) => {
        // console.log(y);
        return "hallo_Y";
    }

    getKritBColors = (dc, dcw, c, idx, cp) => {
        // let colors = dcw;
        let colors = [...dc];
        let af = 0;
        for (let i = 1; i < cp.length; i++) {
            if (cp[i] > 40) {
                af++;
            }
        }
        if (af > 0) {
            colors[idx] = c;
        }
        return colors;
    }

    render() {
        let colorvars = [];
        let i = -1;
        do {
            i++;
            let colorvar = getComputedStyle(document.documentElement).getPropertyValue(
                `--color-wheel-${i + 1}`,
            );
            if (colorvar.length) colorvars.push(colorvar);
        } while (typeof colorvars[i] !== 'undefined');

        // console.log(colorvars);

        const criteria = [
            "Durchschnittlicher Lösungsgrad in einer Klasse",
            "Abstand der Lösungsgrade in einer Klasse",
            "Unterschied im Lösungsgrad zwischen mehreren Klassen"
        ];

        const dF = this.props.evalData;

        // const columnColorStd = "rgba(50, 205, 50, 0.5)";
        const columnColorStd = colorvars[4];
        // const columnColorAtt = "rgba(255, 99, 71, 0.8)";
        const columnColorAtt = colorvars[0];

        const bumsKoffer = "rgba(186, 2558, 211, 1)";

        // const barColorKritB = colorvars[1];
        // should be variable, won't work... :/
        const barColorKritB = "rgba(127, 128, 134,1 )";

        const fontFamily = '"Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif';

        let labels = [];
        let dataPoints = [];
        let dataColors = [];

        for (let i = 0; i < dF[0].numTasks; i++) {
            // labels[i] = dF[1]["columns"][i + 2]["label"];
            labels[i] = dF[1]["taskNames"][0][i + 2]["value"];
            dataPoints[i] = dF[0].aDegOfSolution[i];
            if (dataPoints[i] < 20 || dataPoints[i] > 80) {
                dataColors[i] = columnColorAtt;
            } else {
                dataColors[i] = columnColorStd;
            }
        }

        let dataColorsWorker = [...dataColors];

        const data = {
            labels,
            datasets: [
                {
                    // label: 'Lösungsgrade von Aufgaben in Prozent [%]',
                    label: criteria[0] + ' [%]',
                    data: dataPoints,
                    backgroundColor: (barElement) => {
                        if (barElement.active === true && this.props.parentState.criterion_b === "yes") {
                            // if (true) {
                            let colors = this.getKritBColors(
                                dataColors,
                                dataColorsWorker,
                                barColorKritB,
                                barElement.index,
                                this.props.evalData[0].crossProducts[barElement.index]
                            );
                            // colors[1] = "green";
                            // console.log(colors);
                            // console.log(barElement);
                            return colors;
                        }
                        else {
                            // console.log("jaja auch ich");
                            // let dataColorsWorker = [...dataColors];
                            // dataColorsWorker[1] = "blue";
                            return dataColorsWorker;
                            // return dataColorsWorker;
                        }
                    },
                    // borderWidth: 2,
                    hoverOffset: 4,
                },
            ],
        };

        const options = {
            responsive: true,
            maintainAspectRatio: false,
            elements: {
                bar: {
                    inflateAmount: -3,
                },
            },
            scales: {
                x: {
                    ticks: {
                        font: {
                            family: fontFamily,
                            size: 14,
                        },
                    },
                },
                y: {
                    min: 0,
                    max: 100,
                },
            },
            plugins: {
                tooltip: {
                    callbacks: {
                        title: (ctx) => {
                            return "Aufgabe " + ctx[0].label + " - Lösungsgrad: " + ctx[0].raw + "%";
                        },
                        // label: (yDatapoint) => { return this.formatYValue(yDatapoint.raw) },
                        label: (ctx) => {
                            if (this.props.parentState.criterion_b === "yes") {
                                let af = 0;
                                let cp = this.props.evalData[0].crossProducts[ctx.dataIndex];
                                // console.log("hi, this is index " + ctx.dataIndex);
                                let rV = "Auffälligkeiten bei " + criteria[1] + " mit ";
                                for (let i = 1; i < cp.length; i++) {
                                    if (cp[i] > 40) {
                                        rV += dF[1]["taskNames"][0][i + 1].value + " (" + cp[i] + "%), ";
                                        af++;
                                    }
                                }
                                if (af === 0) {
                                    rV = "Keine Auffälligkeiten bei " + criteria[1] + ".";
                                }
                                else {
                                    rV = rV.substring(0, rV.length - 2);
                                }
                                return rV;
                            }
                            else {
                                return ctx.dataset.label;
                            }
                        },
                    },
                },
                legend: {
                    position: 'top',
                    // color: 'red',
                    onClick: (evt, legendItem, legend) => {
                        const datasets = legend.legendItems.map((dataset, index) => {
                            return dataset.text;
                        })
                        const idx = datasets.indexOf(legendItem.text);
                        legend.chart.isDatasetVisible(idx) ? legend.chart.hide(idx) : legend.chart.show(idx);
                    },
                    labels: {
                        generateLabels: (chart) => {
                            let vis = [];
                            for (let i = 0; i < chart.data.datasets.length; i++) {
                                if (chart.isDatasetVisible(i) === false) {
                                    vis.push(true);
                                }
                                else {
                                    vis.push(false);
                                }
                            }

                            return chart.data.datasets.map(
                                (dataset, index) => ({
                                    // text: dataset.label + " XXXX ",
                                    text: dataset.label,
                                    fillStyle: columnColorStd,
                                    strokeStyle: columnColorStd,
                                    // fillStyle: "rgba(50, 205, 50, 0.5)",
                                    // strokeStyle: "rgba(50, 205, 50, 0.8)",
                                    hidden: vis[index],
                                })
                            )
                        },
                        boxWidth: 20,

                    }
                },
                title: {
                    display: true,
                    text: dF[1].klasse + " " + dF[1].fach + " " + dF[1].schuljahr,
                    color: 'grey',
                    font: {
                        size: 20,
                        // family: 'EB Garamond,Georgia,Times New Roman,Times,serif',
                        family: fontFamily,
                        weight: 'normal',
                        // style: 'italic'
                    },
                },
                annotation: {
                    annotations: {
                        line80: {
                            type: 'line',
                            yMin: 80,
                            yMax: 80,
                            // borderColor: 'rgba(255, 99, 71, 0.5)',
                            borderColor: colorvars[0],
                            borderWidth: 1,
                            borderDash: [6, 3],
                        },
                        line20: {
                            type: 'line',
                            yMin: 20,
                            yMax: 20,
                            // borderColor: 'rgba(255, 99, 71, 0.5)',
                            borderColor: colorvars[0],
                            borderWidth: 1,
                            borderDash: [6, 3],
                        },
                        labelEx80: {
                            type: 'label',
                            xValue: -0.42,
                            yValue: 90,
                            backgroundColor: 'transparent',
                            content: ['Extrembereich'],
                            rotation: -90,
                            textAlign: 'left',
                            // color: 'rgba(255, 99, 71, 1)',
                            color: colorvars[0],
                            font: {
                                size: 12,
                                // family: 'EB Garamond,Georgia,Times New Roman,Times,serif',
                                family: fontFamily,
                            }
                        },
                        labelEx20: {
                            type: 'label',
                            xValue: -0.42,
                            yValue: 10,
                            backgroundColor: 'transparent',
                            content: ['Extrembereich'],
                            rotation: -90,
                            textAlign: 'left',
                            // color: 'rgba(255, 99, 71, 1)',
                            color: colorvars[0],
                            font: {
                                size: 12,
                                // family: 'EB Garamond,Georgia,Times New Roman,Times,serif',
                                family: fontFamily,
                            }
                        },
                        labelNorm: {
                            type: 'label',
                            xValue: -0.42,
                            yValue: 50,
                            backgroundColor: 'transparent',
                            content: ['mittlere Lösungsgrade'],
                            rotation: -90,
                            textAlign: 'left',
                            color: 'black',
                            // color: colorvars[4],
                            font: {
                                size: 12,
                                // family: 'EB Garamond,Georgia,Times New Roman,Times,serif',
                                family: fontFamily,
                            }
                        },
                    },
                },
            },
        };

        return (
            <>
                <div className="barSizer">
                    <Bar options={options}
                        data={data}
                        ref={this.myBarChartRef}
                    />
                </div>
            </>
        )
    }
}

export default BarChartSingle;
